import "core-js/modules/es.array.push.js";
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5f2d8c78"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "flex items-center cursor-pointer"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "whitespace-nowrap text-ellipsis text-font-white text-[20px]"
}, "福建品尚征信有限公司", -1));
const _hoisted_3 = {
  class: "w-full flex items-start justify-end pr-[360px]"
};
const _hoisted_4 = {
  class: "text-[18px] mb-[37px] font-bold"
};
const _hoisted_5 = {
  class: "w-full flex items-start justify-end pr-[360px]"
};
const _hoisted_6 = {
  key: 0,
  class: "mr-[60px] font-bold"
};
import { getImage } from '@/hooks/global';
import { onMounted, onUnmounted } from 'vue';
export default {
  __name: 'PsNavTop',
  setup(__props) {
    const route = useRoute();
    const router = useRouter();
    const navList = markRaw([{
      name: '1',
      text: '首页',
      route: {
        path: '/'
      }
    }, {
      name: '2',
      text: '产品服务',
      children: [{
        title: '企业征信',
        list: [{
          name: '',
          text: '海丝征信链',
          route: 'https://mrc.psc.com.cn/'
        }, {
          name: '2-1',
          text: '品尚查',
          route: {
            path: '/PsSearchNewView'
          }
        }, {
          name: '2-2',
          text: '人行二代征信解析',
          route: {
            path: '/CreditAnalysisView'
          }
        }, {
          name: '2-3',
          text: '数据API服务',
          route: {
            path: '/ApiView'
          }
        }, {
          name: '2-4',
          text: '信用评价系统',
          route: {
            path: '/CreditEvaluateView'
          }
        }]
      }, {
        title: '两岸服务',
        list: [{
          name: '2-5',
          text: '证照服务',
          route: {
            path: '/ProductView',
            query: {
              type: 1
            }
          }
        },
        // { name: '2-6', text: '金融服务', route: { path: '/ProductView', query: { type: 2 } } },
        {
          name: '2-7',
          text: '生活服务',
          route: {
            path: '/ProductView',
            query: {
              type: 3
            }
          }
        }, {
          name: '2-8',
          text: '创业服务',
          route: {
            path: '/ProductView',
            query: {
              type: 4
            }
          }
        }, {
          name: '2-9',
          text: '征信服务',
          route: {
            path: '/ProductView',
            query: {
              type: 5
            }
          }
        }]
      },
      // { title: '金融服务', list: [
      //   { name: '2-10', text: '小微企业金融服务', route: { path: '/SmallEntServeView' } },
      //   { name: '2-11', text: '供应链金融服务', route: { path: '/SupplyChainsView' } },
      //   { name: '2-12', text: '区块链金融服务', route: { path: '/BlockChainsView' } }
      // ] },
      {
        title: '政务服务',
        list: [{
          name: '2-13',
          text: '数字化招商平台',
          route: {
            path: '/DigitalInvestmentView'
          }
        }, {
          name: '2-14',
          text: '产业数智大脑',
          route: {
            path: '/DigitalBrain'
          }
        }, {
          name: '2-15',
          text: '政策兑现综合服务平台',
          route: {
            path: '/PolicyServicesView'
          }
        }]
      }]
    }, {
      name: '3',
      text: '精品案例',
      route: {
        path: '/DemoView'
      }
    }, {
      name: '4',
      text: '关于品尚',
      route: {
        path: '/AboutView'
      },
      list: [{
        name: '4-1'
      }, {
        name: '4-2',
        text: '新闻动态',
        route: {
          path: '/NewsView'
        }
      }, {
        name: '4-3',
        text: '公司文化',
        route: {
          path: '/CultureView'
        }
      }, {
        name: '4-4',
        text: '加入我们',
        route: {
          path: '/JoinUsView'
        }
      }, {
        name: '4-2',
        text: '新闻动态详情',
        hidden: true,
        route: {
          path: '/NewsDetailView'
        }
      }, {
        name: '4-3',
        text: '公司文化详情',
        hidden: true,
        route: {
          path: '/CultureDetailView'
        }
      }]
    }]);
    const activeIndex = ref('');
    const hiddenNav = ref(false);
    const openMenu = ref(false);
    watch(() => route, (newV, oldV) => {
      navList.forEach(element => {
        if (!element.children) {
          if (newV.path === element.route.path) {
            if (element.list) {
              activeIndex.value = `${element.name}-1`;
            } else {
              activeIndex.value = element.name;
            }
          } else if (element.list) {
            element.list.forEach(el => {
              if (el.route && newV.path === el.route.path) {
                activeIndex.value = el.name;
              }
            });
          }
        } else {
          element.children.forEach(child => {
            child.list.forEach(el => {
              if (newV.fullPath === `${el.route.path}${el.route.query ? '?' + JSON.stringify(el.route.query).replace(new RegExp(':', 'g'), '=').replace(new RegExp('"', 'g'), '').replace(new RegExp(',', 'g'), '&').replace(new RegExp('{', 'g'), '').replace(new RegExp('}', 'g'), '') : ''}`) {
                activeIndex.value = el.name;
              }
            });
          });
        }
      });
    }, {
      deep: true,
      immediate: true
    });
    onMounted(() => {
      window.addEventListener("scroll", handleScroll);
    });
    onUnmounted(() => {
      window.removeEventListener("scroll", handleScroll);
    });
    const handleSelect = key => {
      if (key) {
        activeIndex.value = key;
      }
    };
    const handleOpen = () => {
      openMenu.value = true;
    };
    const handleClose = () => {
      openMenu.value = false;
    };
    const handleScroll = () => {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop > 0) {
        hiddenNav.value = true;
      } else {
        hiddenNav.value = false;
      }
    };
    const navTo = path => {
      router.push(path);
    };
    const openUrl = path => {
      window.open(path);
    };
    return (_ctx, _cache) => {
      const _component_el_image = _resolveComponent("el-image");
      const _component_el_menu_item = _resolveComponent("el-menu-item");
      const _component_el_sub_menu = _resolveComponent("el-sub-menu");
      const _component_el_menu = _resolveComponent("el-menu");
      return _openBlock(), _createElementBlock("div", {
        class: "ps-nav-top fixed w-full px-[360px] h-[90px] flex items-center justify-between top-0 left-0 right-0 z-[3000] bg-gradient-to-r from-[#0E1457] to-[#060A33] transition-all duration-200 ease-linear",
        style: _normalizeStyle(`${hiddenNav.value ? 'display: none !important;' : ''} ${openMenu.value ? 'background-color: #000000 !important;' : ''}`)
      }, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_image, {
        class: "w-[32px] h-[32px] mr-[8px]",
        src: _unref(getImage)('/assets/navbarTop/icon_logo.png')
      }, null, 8, ["src"]), _hoisted_2]), _createVNode(_component_el_menu, {
        "default-active": activeIndex.value,
        mode: "horizontal",
        onSelect: handleSelect,
        onOpen: handleOpen,
        onClose: handleClose,
        ellipsis: false,
        router: true
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(navList), (item, index) => {
          return _openBlock(), _createElementBlock(_Fragment, {
            key: index
          }, [item.children && !hiddenNav.value ? (_openBlock(), _createBlock(_component_el_sub_menu, {
            key: 0,
            index: item.name
          }, {
            title: _withCtx(() => [_createTextVNode(_toDisplayString(item.text), 1)]),
            default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (child, i) => {
              return _openBlock(), _createElementBlock("div", {
                class: "flex flex-col items-start mr-[60px]",
                key: i
              }, [_createElementVNode("div", _hoisted_4, "• " + _toDisplayString(child.title), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(child.list, (el, key) => {
                return _openBlock(), _createElementBlock(_Fragment, {
                  key: key
                }, [el.route.path ? (_openBlock(), _createBlock(_component_el_menu_item, {
                  key: 0,
                  index: el.name,
                  route: el.route
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(el.text), 1)]),
                  _: 2
                }, 1032, ["index", "route"])) : (_openBlock(), _createBlock(_component_el_menu_item, {
                  key: 1,
                  index: el.name,
                  onClick: $event => openUrl(el.route)
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(el.text), 1)]),
                  _: 2
                }, 1032, ["index", "onClick"]))], 64);
              }), 128))]);
            }), 128))])]),
            _: 2
          }, 1032, ["index"])) : item.list && !hiddenNav.value ? (_openBlock(), _createBlock(_component_el_sub_menu, {
            key: 1,
            index: item.name,
            onClick: $event => navTo(item.route)
          }, {
            title: _withCtx(() => [_createTextVNode(_toDisplayString(item.text), 1)]),
            default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.list, (el, key) => {
              return _openBlock(), _createElementBlock(_Fragment, {
                key: key
              }, [!el.hidden ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_withDirectives(_createVNode(_component_el_menu_item, {
                index: el.name,
                route: el.route
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(el.text), 1)]),
                _: 2
              }, 1032, ["index", "route"]), [[_vShow, el.route]])])) : _createCommentVNode("", true)], 64);
            }), 128))])]),
            _: 2
          }, 1032, ["index", "onClick"])) : (_openBlock(), _createBlock(_component_el_menu_item, {
            key: 2,
            index: item.name,
            route: item.route
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(item.text), 1)]),
            _: 2
          }, 1032, ["index", "route"]))], 64);
        }), 128))]),
        _: 1
      }, 8, ["default-active"])], 4);
    };
  }
};